<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.gallery && localService.languageContent.table && localService.galleryTypes && isImageUploadEnabled != null">
    <div *ngIf="!isImageUploadEnabled">
        <div style="text-align: center;margin-top: 10%;">
            <label style="font-weight: normal; margin-left: 15px;">
                <input type="checkbox" [(ngModel)]="isImageUploadEnabled" (change)="onAction(1)" />
                <span
                    class="normal_color full_text_checkbox">{{localService.languageContent.gallery.enable_upload}}</span>
            </label>
        </div>
    </div>
    <div *ngIf="isImageUploadEnabled" class="banner center" style="max-width:800px;">
        <div class="row freeze_height" *ngIf="galleryType == 0">
            <div class="col-12">
                <label style="font-weight: normal; margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isImageUploadEnabled" (change)="onAction(1)" />
                    <span class="normal_color">{{localService.languageContent.gallery.enable_upload}}</span>
                </label>
            </div>
        </div>
        <div class="row freeze_height" *ngIf="wrapper">
            <div class="col-6">
                <label>{{localService.languageContent.gallery.cnt}}</label>
                <span class="en">&nbsp;:&nbsp;{{onGetText(2,'0')}}</span>
            </div>
            <div class="col-6">
                <label>{{localService.languageContent.gallery.size}}</label>
                <label class="en">&nbsp;(in MB)</label>
                <span class="en">&nbsp;:&nbsp;{{onGetText(1,'0')}}&nbsp;</span>
                <button *ngIf="onGetText(1,'0') > 0" class="button_icon danger icon_adjust"
                    (click)="onAction(4)">delete_sweep</button>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-md-7">
                <div class="row">
                    <div class="col-4">
                        <button *ngIf="galleryType != 0" class="button_icon button_icon_color icon_adjust"
                            (click)="onAction(5)" style="float: left; top: 0px !important;">arrow_back</button>
                        {{localService.languageContent.table.action}}
                    </div>
                    <div class="col-8">
                        {{galleryType == 0 ? localService.languageContent.gallery.type :
                        localService.getText(localService.galleryTypes,galleryType.toString())}}
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="row">
                    <div class="col-5">
                        {{localService.languageContent.gallery.cnt}}
                    </div>
                    <div class="col-7">
                        {{localService.languageContent.gallery.size}}
                        <span class="en">&nbsp;(in MB)</span>
                        <button class="button_icon button_icon_color icon_adjust" (click)="onLoad()"
                            style="float: right; top: 0px !important;">refresh</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngFor="let item of wrapper.items">
                <div class="row styled_row freeze_col" *ngIf="item.key != '0'">
                    <div class="col-md-7">
                        <div class="row">
                            <div class="col-4">
                                <button
                                    *ngIf="(galleryType == 0 && !isBusinessOrProductType(item.key, true)) || galleryType != 0"
                                    class="button_icon button_icon_color icon_adjust"
                                    (click)="onAction(3, item.key)">image</button>
                                <button *ngIf="galleryType == 0 && isBusinessOrProductType(item.key, true)"
                                    class="button_icon button_icon_color icon_adjust"
                                    (click)="onAction(2, item.key)">account_tree</button>
                            </div>
                            <div class="col-8">
                                <span *ngIf="galleryType == 0">
                                    {{localService.getText(localService.galleryTypes,item.key)}}
                                </span>
                                <span *ngIf="galleryType != 0" [ngClass]="localService.getLanguageCode(item.v3)">
                                    {{item.v4}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="row">
                            <div class="col-5">
                                <div class="en number-only">
                                    {{item.v2}}
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="en number-only">
                                    <span>{{item.v1}}&nbsp;</span>
                                    <button *ngIf="item.v2 != '0' && item.v2 != '0.000'"
                                        class="button_icon danger icon_adjust"
                                        (click)="onAction(4, item.key)">delete_sweep</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-gallery-config [(isOpenPopup)]="isGalleryPopupOpen" [galleryType]="selectedGalleryType"
        [parentId]="selectedParentId" [businessId]="businessId"
        (onClose)="onClosesGalleryPopup($event)"></app-gallery-config>
</div>